import {Component, inject, OnInit} from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {ReportService} from '@services/report/report.service';

@Component({
  selector: 'app-reports-requests',
  imports: [
    RouterOutlet
  ],
  templateUrl: './reports-requests.component.html',
  standalone: true,
  styleUrl: './reports-requests.component.scss'
})
export class ReportsRequestsComponent implements OnInit {

  private reportService = inject(ReportService);

  ngOnInit() {
    this.reportService.fetchReportRequests()
      .subscribe((reportRequests: any) => {
        this.reportService.updateRequestsList(reportRequests);
      });
  }
}
